export default "__VITE_ASSET__4jCFXVRA__"